// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1L-1J","list":"PatternAutocomplete_list__1ucLm"};